import * as reduxModule from 'redux'
import {applyMiddleware, compose, createStore} from 'redux'
import reducer from './reducers'
import thunk from 'redux-thunk'

reduxModule.__DO_NOT_USE__ActionTypes.REPLACE = '@@redux/INIT';

const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        }) : compose

const enhancer = composeEnhancers(
    applyMiddleware(thunk)
)

const store = createStore(reducer(), enhancer)

store.asyncReducers = {}

export const injectReducer = (key, reducer) => {
    if ( store.asyncReducers[key] )
    {
        return
    }
    store.asyncReducers[key] = reducer
    store.replaceReducer(reducer(store.asyncReducers))
    return store
};

export default store
